import styled from 'styled-components';
import { Card } from '../Card/Card';
export var StyledToggleCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "StyledToggleCard",
  componentId: "c11n-8-111-1__sc-1qv1mi1-0"
})([""]);